export default {
  common: {
    login: "로그인",
    loginRequired: "로그인이 필요합니다.",
    logout: "로그아웃",
    signup: "회원가입",
    home: "홈",
    search: "검색",
    cancel: "취소",
    confirm: "확인",
    save: "저장",
    delete: "삭제",
    edit: "수정",
    welcome: "환영합니다",
    loading: "로딩 중...",
    error: "오류가 발생했습니다",
    noData: "데이터가 없습니다",
    number: "번호",
    title: "제목",
    date: "날짜",
    type: "유형",
    status: "상태",
    canceled: "취소",
    approved: "승인",
    rejected: "거절",
    waiting: "대기중",
    reset: "초기화",
    submit: "제출",
    success: "성공",
    failed: "실패",
    amountMustBeGreaterThan0: "금액은 0보다 커야 합니다",
  },
  header: {
    announcement: "시작되었습니다!",
    login: "로그인",
    register: "회원가입",
    casino: "라이브 카지노",
    slotGame: "슬롯 게임",
    liveSports: "라이브 스포츠",
    cashIn: "입금",
    cashOut: "출금",
    needHelp: "도움이 필요하세요?",
    honorific: "님",
    chip: "칩",
    point: "포인트",
    partnerPage: "파트너 페이지",
  },
  slider: {
    casino: {
      subtitle: "SHOGUN LIVE CASINO",
      title1: "라이브 카지노",
      title2: "모든 플레이어의 만족을 보장합니다",
    },
    slot: {
      subtitle: "SHOGUN SLOT GAME",
      title1: "라이브 슬롯",
      title2: "모든 플레이어의 만족을 보장합니다",
    },
    sports: {
      subtitle: "SHOGUN SPORTS",
      title1: "라이브 스포츠",
      title2: "모든 플레이어의 만족을 보장합니다",
    },
  },
  homePage: {
    casino: {
      title: "라이브 카지노",
      subtitle: "SHOGUN CASINO",
    },
    slot: {
      title: "슬롯",
      subtitle: "SHOGUN SLOT",
    },
  },
  gameList: {
    showAll: "모두 보기",
    underMaintenance: "점검중입니다.",
  },
  board: {
    faq: {
      subtitle: "자주 묻는 질문",
      title: "FAQ",
      viewMore: "더 많은 FAQ 보기",
      items: [
        {
          id: 1,
          title: "'SHOGUN'은 어떤 회사인가요?",
          content: "'SHOGUN'은 온라인 카지노와 모바일 카지노 서비스를 제공하는 글로벌 게임 플랫폼입니다. 24시간 연중무휴로 운영되며, 100종 이상의 다양한 카지노 게임을 제공합니다."
        },
        {
          id: 2,
          title: "사이트는 안전한가요?",
          content: "네, SHOGUN은 최신 보안 시스템을 도입하여 회원님들의 개인정보와 자산을 안전하게 보호합니다. 모든 거래는 암호화되어 처리되며, 공정한 게임 환경을 제공하기 위해 정기적인 감사를 실시합니다."
        },
        {
          id: 3,
          title: "게임이 많이 있나요?",
          content: "네, SHOGUN은 100개 이상의 다양한 게임을 제공합니다. 라이브 카지노, 슬롯 게임, 미니 게임 등 다양한 장르의 게임을 즐기실 수 있으며, 특히 프로그레시브 잭팟 게임에서는 큰 상금을 획득하실 수 있습니다."
        },
        {
          id: 4,
          title: "입금과 출금은 어떻게 되나요?",
          content: "SHOGUN은 다양한 입출금 방식을 지원합니다. 은행 송금, 암호화폐(USDT) 등 편리한 방법으로 입출금이 가능하며, 입금은 5-10분 내에 처리됩니다."
        }
      ]
    },
    notice: {
      subtitle: "공지사항",
      title: "최신 공지",
      viewMore: "더 많은 공지 보기",
    },
  },
  footer: {
    ourPartners: "우리의 파트너",
    copyright: "저작권 2024 SHOGUN. 모든 권리 보유",
    casino: "라이브 카지노",
    slotGame: "슬롯 게임",
    miniGame: "미니 게임",
  },
  auth: {
    login: "로그인",
    register: "회원가입",
    username: "사용자 이름",
    password: "비밀번호",
    passwordConfirm: "비밀번호 확인",
    passwordMismatch: "비밀번호가 일치하지 않습니다.",
    rememberPassword: "비밀번호 기억하기",
    captcha: "CAPTCHA 텍스트를 입력하세요",
    referrer: "추천인 코드",
    phone: "전화번호",
    nameBank: "은행명",
    numberBank: "계좌번호",
    userBank: "예금주",
    loginFailed: "로그인에 실패했습니다.",
    registerFailed: "회원가입에 실패했습니다.",
  },
  maintenance: {
    title: "곧 돌아오겠습니다!",
    message: "시스템 점검 중입니다. 불편을 드려 죄송합니다.",
  },
  homePopup: {
    selectList: "목록 선택",
    deposit: "입금",
    withdrawal: "출금",
    bankingHistory: "거래내역",
    pointToChip: "포인트 전환",
    notice: "공지사항",
    inquiry: "문의하기",
    myInfo: "내정보",
    betHistory: "베팅내역",
    faq: "자주 묻는 질문",
  },
  betting: {
    name: "베팅명",
    game: "게임",
    type: "유형",
    amount: "금액",
    date: "날짜",
    status: {
      win: "승리",
      lose: "패배",
      bet: "베팅",
    },
  },
  deposit: {
    notice: "입금 정보를 정확히 확인해 주세요",
    info: "입금은 5-10분 내로 처리됩니다",
    currentBalance: "현재 잔액",
    amount: "입금 금액",
    usdtAmount: "USDT 입금 금액",
    requestAccount: "입금계좌 요청",
    requestUsdtAddress1: "폴리곤 USDT 주소",
    requestUsdtAddress2: "트론 USDT 주소",
    myWallet: "내 지갑",
    bottomNotice: "도움이 필요하시면 고객센터로 문의해 주세요",
    title: "입금",
    normalDeposit: "일반 입금",
    usdtDeposit: "USDT 입금",
  },
  withdrawal: {
    notice: "출금 정보를 정확히 확인해 주세요",
    currentBalance: "현재 잔액",
    myWallet: "내 지갑",
    walletAddress: "지갑주소",
    amount: "출금 금액",
    usdtAmount: "USDT 출금 금액",
    password: "출금 비밀번호",
    title: "출금",
    normalWithdrawal: "일반 출금",
    usdtWithdrawal: "USDT 출금",
  },
  banking: {
    bankAccountRequired: "계좌 정보가 없습니다",
  },
  bankinghistory: {
    beforeBalance: "입금 전 잔액",
    requestAmount: "신청 금액",
    afterBalance: "입금 후 잔액",
  },
  profile: {
    username: "사용자 이름",
    balance: "보유금액",
    point: "포인트",
    changePassword: "비밀번호 변경",
    currentPassword: "현재 비밀번호",
    newPassword: "새 비밀번호",
    confirmPassword: "비밀번호 확인",
    passwordChanged: "비밀번호가 성공적으로 변경되었습니다",
    passwordMismatch: "비밀번호가 일치하지 않습니다",
    invalidPassword: "현재 비밀번호가 올바르지 않습니다",
  },
  notice: {
    unread: "미확인",
    read: "확인",
  },
  inquiry: {
    title: "문의 제목",
    select: "문의 유형을 선택하세요",
    writer: "작성자",
    placeholder: "문의 내용을 입력하세요 (최대 100자)",
    types: {
      deposit: "입금 문의",
      withdrawal: "출금 문의",
      account: "입금계좌 요청",
      other: "기타 문의",
    },
    question: "문의 내용",
    answer: "답변",
    status: "상태",
    pending: "답변 대기중",
    inProgress: "답변 중",
    completed: "답변 완료",
    unknown: "알 수 없음",
    empty: "문의 내역이 없습니다",
    reply: "답변하기",
    send: "보내기",
    note: "답변 대기중",
    showMore: "더보기",
    showLess: "접기",
    newInquiry: "새 문의하기",
    delete: "삭제",
    deleteConfirmation: "정말 삭제하시겠습니까?",
  },
  point: {
    currentBalance: "현재 포인트",
    amount: "전환 금액",
    enterAmount: "금액을 입력하세요",
    password: "비밀번호",
    enterPassword: "비밀번호를 입력하세요",
    convert: "전환하기",
    invalidAmount: "유효하지 않은 금액입니다",
    convertSuccess: "포인트 전환이 완료되었습니다",
  },
}; 